import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  Box,
  Text,
  Radio,
  RadioGroup,
  Stack,
  Button,
  Flex,
  Badge,
  VStack,
  Divider,
} from '@chakra-ui/react';
import { useState } from 'react';

const questions = [
  {
    id: 0,
    pergunta: 'ARSG_T1_M_1 Como você avalia sua saúde geral nesta semana?',
    opcoes: [
      'ARSG_T1_M_1.1 Minha saúde está ótima.',
      'ARSG_T1_M_1.2 Minha saúde está boa.',
      'ARSG_T1_M_1.3 Minha saúde está mais ou menos, com alguns desconfortos.',
      'ARSG_T1_M_1.4 Minha saúde está ruim.',
      'ARSG_T1_M_1.5 Minha saúde está muito ruim.',
      'ARSG_T1_M_1.6 Minha saúde está péssima.',
    ],
  },
  {
    id: 1,
    pergunta: 'ARSG_T1_M_2 Como você tem dormido nos últimos dias?',
    opcoes: [
      'ARSG_T1_M_2.1 Durmo muito bem.',
      'ARSG_T1_M_2.2 Durmo bem.',
      'ARSG_T1_M_2.3 Durmo razoavelmente.',
      'ARSG_T1_M_2.4 Durmo mal.',
      'ARSG_T1_M_2.5 Durmo muito mal.',
      'ARSG_T1_M_2.6 Não consigo dormir.',
    ],
  },
  {
    id: 2,
    pergunta: 'ARSG_T1_M_3 Como está sua alimentação?',
    opcoes: [
      'ARSG_T1_M_3.1 Excelente.',
      'ARSG_T1_M_3.2 Boa.',
      'ARSG_T1_M_3.3 Regular.',
      'ARSG_T1_M_3.4 Ruim.',
      'ARSG_T1_M_3.5 Muito ruim.',
      'ARSG_T1_M_3.6 Péssima.',
    ],
  },
  {
    id: 3,
    pergunta: 'ARSG_T1_M_1 Como está seu nível de estresse?',
    opcoes: [
      'ARSG_T1_M_1.1 Sem estresse.',
      'ARSG_T1_M_1.2 Pouco estresse.',
      'ARSG_T1_M_1.3 Estresse moderado.',
      'ARSG_T1_M_1.4 Muito estresse.',
      'ARSG_T1_M_1.5 Estresse extremo.',
      'ARSG_T1_M_1.6 Não aguento mais.',
    ],
  },
  {
    id: 4,
    pergunta: 'ARSG_T1_M_2 Você tem praticado atividades físicas?',
    opcoes: [
      'ARSG_T1_M_2.1 Sim, regularmente.',
      'ARSG_T1_M_2.2 Sim, às vezes.',
      'ARSG_T1_M_2.3 Raramente.',
      'ARSG_T1_M_2.4 Não.',
      'ARSG_T1_M_2.5 Não posso praticar.',
      'ARSG_T1_M_2.6 Tenho dificuldades para praticar.',
    ],
  },
  {
    id: 5,
    pergunta: 'ARSG_T1_M_3 Como está sua saúde emocional?',
    opcoes: [
      'ARSG_T1_M_3.1 Ótima.',
      'ARSG_T1_M_3.2 Boa.',
      'ARSG_T1_M_3.3 Regular.',
      'ARSG_T1_M_3.4 Ruim.',
      'ARSG_T1_M_3.5 Muito ruim.',
      'ARSG_T1_M_3.6 Péssima.',
    ],
  },
  {
    id: 6,
    pergunta: 'ARSG_T1_M_1 Você tem seguido as orientações médicas?',
    opcoes: [
      'ARSG_T1_M_1.1 Sim, sempre.',
      'ARSG_T1_M_1.2 Sim, na maioria das vezes.',
      'ARSG_T1_M_1.3 Às vezes.',
      'ARSG_T1_M_1.4 Raramente.',
      'ARSG_T1_M_1.5 Não.',
      'ARSG_T1_M_1.6 Não recebi orientações.',
    ],
  },
  {
    id: 7,
    pergunta: 'ARSG_T1_M_2 Como você avalia seu bem-estar geral?',
    opcoes: [
      'ARSG_T1_M_2.1 Excelente.',
      'ARSG_T1_M_2.2 Muito bom.',
      'ARSG_T1_M_2.3 Bom.',
      'ARSG_T1_M_2.4 Regular.',
      'ARSG_T1_M_2.5 Ruim.',
      'ARSG_T1_M_2.6 Péssimo.',
    ],
  },
];

export const QuestionnaireModal = ({ isOpen, onClose }: any) => {
  const [feedback, setFeedback] = useState(0);
  const [final, setFinal] = useState(0);
  const [step, setStep] = useState(0);
  const [isLast, setIsLast] = useState(false);
  const [answers, setAnswers] = useState<string[]>([]);
  const [value, setValue] = useState('');

  const handleNext = () => {
    if (step === 2) setFeedback(1);
    if (step === 5) setFeedback(2);
    if (step === 7) setFeedback(3);
    if (!isLast) {
      setAnswers([...answers, value]);
      setValue('');
      setStep(step + 1);
    }
  };

  const resetState = () => {
    setStep(0);
    setFeedback(0);
    setFinal(0);
    setAnswers([]);
    setValue('');
    setIsLast(false);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={resetState} size="4xl">
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />

        <ModalBody p={6}>
          {feedback === 1 ? (
            <>
              <Text fontSize="lg" fontWeight="bold" mb={4}>
                Resultado (Rótulo): Estado de Saúde
              </Text>

              <Text>
                Status:{' '}
                <Badge
                  bg="red"
                  top="-3"
                  right="-1.5"
                  fontFamily="Rubik"
                  color="#fff"
                  px="2"
                  py="1.5"
                  fontSize="12"
                  borderRadius={50}
                />
              </Text>
              <Text mt={2}>Score: 4</Text>

              <Box mt={4} fontSize="sm" color="gray.600">
                FeedBack: Sua percepção de saúde nesta semana está boa. Mantenha
                o pré-natal e observe mudanças importantes. (classificação de
                sinal, não é diagnóstico)
              </Box>

              <Flex justify="flex-end" mt={6}>
                <Button
                  colorScheme="blue"
                  onClick={() => {
                    setFeedback(0);
                    setFinal(1);
                  }}
                >
                  Próximo
                </Button>
              </Flex>
            </>
          ) : final === 1 ? (
            <>
              <Text
                fontSize="lg"
                fontWeight="bold"
                mt={10}
                mb={4}
                textAlign="center"
              >
                Obrigado por suas respostas!
              </Text>

              <Box mt={4} fontSize="sm" color="gray.600" w="100%">
                {' '}
                <Text>
                  Você concluiu o primeiro questionário. Agora vamos iniciar o
                  questionário 2 com novas perguntas sobre seu bem-estar.
                </Text>
              </Box>

              <Flex justify="flex-end" mt={6}>
                <Button colorScheme="blue" onClick={() => setFinal(0)}>
                  Próximo
                </Button>
              </Flex>
            </>
          ) : feedback === 2 ? (
            <>
              <Text fontSize="lg" fontWeight="bold" mb={4}>
                Resultado (Rótulo): Estado de Saúde
              </Text>

              <Text>
                Status:{' '}
                <Badge
                  bg="green"
                  top="-3"
                  right="-1.5"
                  fontFamily="Rubik"
                  color="#fff"
                  px="2"
                  py="1.5"
                  fontSize="12"
                  borderRadius={50}
                />
              </Text>
              <Text mt={2}>Score: 17</Text>

              <Box mt={4} fontSize="sm" color="gray.600">
                FeedBack: Sua percepção de saúde nesta semana está boa. Mantenha
                o pré-natal e observe mudanças importantes. (classificação de
                sinal, não é diagnóstico)
              </Box>

              <Flex justify="flex-end" mt={6}>
                <Button
                  colorScheme="blue"
                  onClick={() => {
                    setFeedback(0);
                    setFinal(2);
                  }}
                >
                  Próximo
                </Button>
              </Flex>
            </>
          ) : final === 2 ? (
            <>
              <Text
                fontSize="lg"
                fontWeight="bold"
                mt={10}
                mb={4}
                textAlign="center"
              >
                Ótimo progresso!
              </Text>

              <Box mt={4} fontSize="sm" color="gray.600" w="100%">
                {' '}
                <Text>
                  Você finalizou o segundo questionário. Vamos agora para o
                  último questionário, com apenas 2 perguntas finais.
                </Text>
              </Box>

              <Flex justify="flex-end" mt={6}>
                <Button colorScheme="blue" onClick={() => setFinal(0)}>
                  Próximo
                </Button>
              </Flex>
            </>
          ) : feedback === 3 ? (
            <>
              <Text fontSize="lg" fontWeight="bold" mb={4}>
                Resultado (Rótulo): Estado de Saúde
              </Text>

              <Text>
                Status:{' '}
                <Badge
                  bg="yellow"
                  top="-3"
                  right="-1.5"
                  fontFamily="Rubik"
                  color="#fff"
                  px="2"
                  py="1.5"
                  fontSize="12"
                  borderRadius={50}
                />
              </Text>
              <Text mt={2}>Score: 12</Text>

              <Box mt={4} fontSize="sm" color="gray.600">
                FeedBack: Sua percepção de saúde nesta semana está boa. Mantenha
                o pré-natal e observe mudanças importantes. (classificação de
                sinal, não é diagnóstico)
              </Box>

              <Flex justify="flex-end" mt={6}>
                <Button
                  colorScheme="blue"
                  onClick={() => {
                    setFeedback(0);
                    setFinal(0);
                    setIsLast(true);
                  }}
                >
                  Próximo
                </Button>
              </Flex>
            </>
          ) : !isLast ? (
            <>
              <Text fontWeight="bold" mb={4}>
                {questions[step].pergunta}
              </Text>

              <RadioGroup value={value} onChange={setValue}>
                <Stack>
                  {questions[step].opcoes.map((opcao, i) => (
                    <Box p={3} border="1px solid #E2E8F0" borderRadius="md">
                      <Radio value={opcao}>{opcao}</Radio>
                    </Box>
                  ))}
                </Stack>
              </RadioGroup>

              <Flex justify="flex-end" mt={6}>
                <Button
                  colorScheme="blue"
                  onClick={handleNext}
                  isDisabled={!value}
                >
                  Próximo →
                </Button>
              </Flex>
            </>
          ) : (
            <>
              <Text fontSize="lg" fontWeight="bold" mb={4}>
                Finalização
              </Text>

              <VStack spacing={4} textAlign="center" py={6}>
                <Text fontSize="2xl" fontWeight="bold">
                  Questionário Concluído!
                </Text>

                <Text fontSize="sm" color="gray.600">
                  Obrigado por responder ao questionário. Suas respostas foram
                  registradas com sucesso.
                </Text>

                <Text fontSize="sm" color="gray.600">
                  O profissional de saúde responsável receberá suas informações
                  e entrará em contato se necessário.
                </Text>
              </VStack>

              <Divider mt={4} />
              <Flex justify="flex-end" mt={6}>
                <Button
                  variant="outline"
                  colorScheme="blue"
                  onClick={resetState}
                >
                  Histórico de Acompanhamento
                </Button>

                <Button ml={5} colorScheme="blue" onClick={resetState}>
                  Fechar
                </Button>
              </Flex>
            </>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
